import React from "react";

const TopFilter = ({ filters, activeFilter, onFilterChange, hidden = false }) => {
  if (hidden || !filters?.length) {
    return null;
  }

  return (
    <div className="inline-flex xl:ml-4 flex-wrap gap-3.5 rounded-sm bg-[#F5F5F5] px-3  py-1.5">
      {filters.map((filter) => {
        const isActive = activeFilter === filter;

        return (
          <button
            key={filter}
            type="button"
            onClick={() => onFilterChange(filter)}
            className={[
              "rounded px-4 py-2  tracking-[6%] text-sm leading-4 transition",
              isActive
                ? "bg-[#923D8C]  text-white"
                : "bg-transparent text-black hover:bg-white",
            ].join(" ")}
          >
            {filter}
          </button>
        );
      })}
    </div>
  );
};

export default TopFilter;
